<!--
   Created by qing on 2020/8/3
   Des: 
-->
<template>
  <div>
    <van-cell class="ry-form__out-request" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{content}}
        </div>

        <template v-if="!isRead">
          <!--文本输入型-->
          <template v-if="current.requestType === 0">
            <van-field
              style="padding: 0 !important;"
              :disabled="isReadOnly"
              v-model="currentRow[dataId]"
              @blur="inputBlur"
              @focus="inputFocus"
              @change="controlChange"
              :placeholder="current.fieldDes">
              <van-button
                v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
                slot="button"
                size="small"
                style="color: #ffffff;"
                :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
                @click="onClickBtn"
                type="primary">
                {{current.buttonName}}
              </van-button>
            </van-field>
          </template>

          <!--下拉框类型-->
          <template v-if="current.requestType === 1">
            <div>
              <div
                @click="selectVisibleChange"
                :style="{cursor: isReadOnly ? 'not-allowed' : 'pointer', backgroundColor: isReadOnly ? '#F5F7FA' : '#fff'}"
                class="ry-form__dropdown-input">
                <div class="select-item">
                  <div v-if="currentRow[dataId]">
                    {{currentRow[dataId]}}
                  </div>
                  <div v-else>
                    {{current.fieldDes}}
                  </div>
                </div>
                <van-icon
                  v-if="currentRow[dataId] && !isReadOnly"
                  name="close"
                  class="close-btn"
                  @click.stop="clearData">
                </van-icon>
              </div>

              <div @click.stop.prevent>
                <van-action-sheet
                  class="ry-form-action-sheet"
                  v-model="show"
                  :title="current.title"
                  get-container="body"
                  @select="onSelect"
                  :close-on-click-action="true"
                  :actions="actions">
                </van-action-sheet>
              </div>
            </div>
          </template>
        </template>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__out-request-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="isRead">
            {{content}}
          </div>
          <div v-else class="out-request-compact-container">

            <!--文本输入型-->
            <template v-if="current.requestType === 0">
              <van-field
                style="padding: 0 !important;"
                :disabled="isReadOnly"
                v-model="currentRow[dataId]"
                @blur="inputBlur"
                @focus="inputFocus"
                @change="controlChange"
                :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请输入内容'">
                <van-button
                  v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
                  slot="button"
                  size="small"
                  style="color: #ffffff;"
                  :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
                  @click="onClickBtn"
                  type="primary">
                  {{current.buttonName}}
                </van-button>
              </van-field>
            </template>

            <!--下拉框类型-->
            <template v-if="current.requestType === 1">
              <div>
                <div
                  @click="selectVisibleChange"
                  :style="{cursor: isReadOnly ? 'not-allowed' : 'pointer', backgroundColor: isReadOnly ? '#F5F7FA' : '#fff'}"
                  class="ry-form__dropdown-input">
                  <div class="select-item">
                    <div v-if="currentRow[dataId]">
                      {{currentRow[dataId]}}
                    </div>
                    <div v-else style="color: #bbbec4; padding: 0;">
                      {{current.fieldDes || '请选择'}}
                    </div>
                  </div>
                  <van-icon
                    v-if="currentRow[dataId] && !isReadOnly"
                    name="close"
                    class="close-btn"
                    @click.stop="clearData">
                  </van-icon>
                </div>

                <div @click.stop.prevent>
                  <van-action-sheet
                    class="ry-form-action-sheet"
                    v-model="show"
                    :title="current.title"
                    get-container="body"
                    @select="onSelect"
                    :close-on-click-action="true"
                    :actions="actions">
                  </van-action-sheet>
                </div>
              </div>
            </template>
          </div>
        </template>
      </van-field>
    </div>
  </div>

</template>

<script>
  import { current } from './mixin'
  import {TRIGGER_TYPE_BLUR, TRIGGER_TYPE_FOCUS, TRIGGER_TYPE_BUTTON} from "../../types";
  export default {
    mixins: [current],
    data() {
      return {
        TRIGGER_TYPE_BUTTON,
        show: false,
        dataOrigin: {
          init: false,
          dataList: [],
          currentPage: 1,
          pageSize: 1000,
          totalPage: 0,
          totalCount: 0
        },
        selectConfig: {
          visible: false,
          searchInput: '',
          value: '',
          dataList: [],
          searchResults: [],
        },
      }
    },
    computed: {
      content() {
        return this.currentRow[this.dataId] ? this.currentRow[this.dataId] : '暂无内容'
      },
      checkList () {
        return this.current.checkList()
      },
      errorMessage () {
        if (this.isError) {
          if (!this.current.checkWriteValue()) {
            return '此项是必填项'
          } else if (!this.current.lengthCheck()) {
            return this.current.lengthCheckStr
          }  else if (!this.current.regExpCheck()) {
            return this.current.regExpCheckStr
          } else {
            return '输入数据不合法'
          }
        } else {
          return ''
        }
      },
      actions () {
        if (this.dataOrigin.dataList.length) {
          return this.dataOrigin.dataList.map(item => {
            return {
              name: item,
              color: 'transparent'
            }
          })
        } else {
          return [{ name: '暂无数据', disabled: true }]
        }
      },
    },
    created() {
    },
    methods: {

      onClickBtn() {
        if (this.current.showAlert) {
          this.$dialog.confirm({
            title: '确认信息',
            message: this.current.alertText,
          })
            .then(() => {
              // on confirm
              this.requestTmpSubmit()
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.requestTmpSubmit()
        }
      },

      // Input 失去焦点时触发
      inputBlur() {
        if(this.current.triggerType === TRIGGER_TYPE_BLUR) {
          this.requestTmpSubmit()
        }
      },

      // Input 获得焦点时触发
      inputFocus() {
        if(this.current.triggerType === TRIGGER_TYPE_FOCUS) {
          this.requestTmpSubmit()
        }
      },

      requestTmpSubmit() {
        const formSet = this.current.root
        this.$store.dispatch('actionRequestTmpSubmit', {
          companyId: formSet.companyId,
          appId: formSet.appId,
          formId: formSet.formId,
          instanceId: formSet.instanceId,
          fieldId: this.current.dataId,
          rowIdx: this.index + 1,
          tmpTopic: formSet.tmpTopic,
          data: formSet.getValues()
        }).then(res => {

        }).catch(console.error)
      },

      selectVisibleChange() {
        const toast = this.$toast.loading({ message: '加载中...' })
        this.selectConfig.visible = true
        const formSet = this.current.root
        this.$store.dispatch('actionRequestDataGet', {
          companyId: formSet.companyId,
          appId: formSet.appId,
          formId: formSet.formId,
          instanceId: formSet.instanceId,
          fieldId: this.current.dataId,
          rowIdx: this.index + 1,
          tmpTopic: formSet.tmpTopic,
          data: formSet.getValues()
        }).then(res => {
          this.dataOrigin.dataList.splice(0, this.dataOrigin.dataList.length, ...res)
          this.selectConfig.dataList.splice(0, this.selectConfig.dataList.length, ...res)
          this.show = true
        })
          .catch(console.error)
          .finally(() => {
            toast.clear()
            this.dataOrigin.init = true
          })
      },

      clearData() {
        this.currentRow[this.dataId] = ''
        this.controlChange()
      },

      onSelect (opt) {
        this.currentRow[this.dataId] = opt.name
        this.controlChange()
      },
    }
  }
</script>

<style lang="less">

  .ry-form__out-request {
    .ry-form__dropdown-input {
      font-size: 14px;
      line-height: 24px;
      height: 34px;
      border: 1px solid #DCDFE6;
      border-radius: 0;
      padding: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .select-item {
        div {
          padding: 0 12px;
          border-radius: 24px;
          margin: 2px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 30px;
          line-height: 30px;
        }
      }
    }
  }
</style>